import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { StatCard } from "./ui";
import ReportsList from "./Reports";

// شاشة المشرف الإرشادي: اعتماد التقارير الأسبوعية القادمة من المرشدين
export default function FollowUpSupervisor() {
  const [s, setS] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { api.get("/followup/summary").then((r) => setS(r.data)).catch(() => {}); }, [tick]);
  return (
    <div className="space-y-4" dir="rtl">
      <div>
        <div className="text-sm text-[#3E6A56] font-medium mb-1">برنامج كيان</div>
        <h1 className="text-3xl font-bold text-[#1A201C]" style={{ fontFamily: "IBM Plex Sans Arabic" }}>متابعة الطالب — اعتماد التقارير</h1>
        <p className="text-[#4A554E] mt-1">يغلق المرشد متابعة الأسبوع فيصلك التقرير هنا. اعتمده (مع ملاحظتك) ليتمكن المرشد من إرساله لولي الأمر.</p>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <StatCard label="طلاب تحت المتابعة" value={s?.active ?? "—"} />
        <StatCard label="بانتظار اعتمادك" value={s?.pending ?? "—"} tone="text-amber-700" />
        <StatCard label="معتمد ولم يُرسل" value={s?.approved ?? "—"} tone="text-sky-700" />
      </div>
      <ReportsList isAdmin refreshKey={tick} key={tick} />
      <button className="text-xs underline text-[#4A554E]" onClick={() => setTick((n) => n + 1)}>تحديث</button>
    </div>
  );
}
